import { render, staticRenderFns } from "./Case.vue?vue&type=template&id=821d93fe&scoped=true"
import script from "./Case.vue?vue&type=script&lang=js"
export * from "./Case.vue?vue&type=script&lang=js"
import style0 from "./Case.vue?vue&type=style&index=0&id=821d93fe&prod&lang=scss&scoped=true"
import style1 from "./Case.vue?vue&type=style&index=1&id=821d93fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821d93fe",
  null
  
)

export default component.exports